function initDreamVerticalCarousels() {
    const dreamCarousels = document.querySelectorAll('.maje-dream-vertical-swiper');

    dreamCarousels.forEach(customSwiper => {
        const swiper = new Swiper(customSwiper, {
            direction: 'vertical',
            loop: true,
            slidesPerView: 1,
            speed: 1000,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
        });
    })

    dreamCarousels.forEach(customSwiper => {
        const slides = customSwiper.querySelectorAll('.swiper-slide');
        
        let slideHeight = 0;
        slides.forEach(slide => {
            const slideContent = slide.querySelector('.maje-dream-vertical-slide__text-wrapper');
            
            if (slideContent.offsetHeight > slideHeight) {
                slideHeight = slideContent.offsetHeight;
            }
        })

        customSwiper.style.height = `${slideHeight}px`;

        // slides.forEach(slide => {
        //     slide.style.height = `${slideHeight}px`;
        // })
    })

}

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initDreamVerticalCarousels);
}

window.addEventListener('DOMContentLoaded', initDreamVerticalCarousels);